module.exports = require('onyx-common/react-fast-compare')
